import beTwMerge from '@/utils/beTwMerge';
import { getAnchorId, getComponentMargin, isRichTextEmpty } from '@/utils/builderUtils';
import ResponsiveImage, { ResponsiveImageSet } from '@/utils/ResponsiveImage';
import RichText from '@/components/RichText/RichText';
import { subHeadersStyles } from '@/consts/builder';

type ResponsiveSet = {
  desktopImage?: string;
  mobileImage?: string;
};

type CustomerServiceHeroProps = {
  background: ResponsiveSet;
  imgAlt: string;
  title: string;
  titleTag: 'h1' | 'h2';
  description: string;
  isWhiteBackgroundVisible: boolean;
  textBoxPosition: 'left' | 'right';
  textColor: 'black' | 'white';
  anchorLinkID: string;
  margin: boolean;
};

export default function CustomerServiceHero({
  background,
  imgAlt,
  title,
  titleTag,
  description,
  isWhiteBackgroundVisible,
  textBoxPosition,
  textColor,
  anchorLinkID,
  margin,
}: CustomerServiceHeroProps) {
  const TitleTag = titleTag || 'h2';
  const desktopImgSrcs: ResponsiveImageSet = [
    {
      src: background?.desktopImage || '',
      size: { width: 967, height: 350, aspectRatio: 967 / 350 },
      breakpoint: 1023,
    },
  ];
  const mobileImgSrcs: ResponsiveImageSet = [
    {
      src: background?.mobileImage || '',
      size: { width: 390, height: 325, aspectRatio: 390 / 325 },
      breakpoint: 320,
    },
  ];
  const isTextWhite = textColor === 'white';

  return (
    <div className={beTwMerge('', getComponentMargin(margin))} {...getAnchorId(anchorLinkID)}>
      <div className="tw-w-full">
        <div className="tw-w-full tw-flex tw-flex-col tw-relative">
          <div className="tw-w-full bs-tablet:tw-max-h-[350px] bs-tablet:tw-aspect-[967/350] tw-inline-block tw-overflow-hidden">
            <ResponsiveImage
              preload
              loading="eager"
              fetchpriority="high"
              className="bs-tablet:tw-block tw-hidden tw-w-full tw-h-full tw-object-cover"
              sources={desktopImgSrcs}
              alt={imgAlt || title}
            />
            <ResponsiveImage
              preload
              loading="eager"
              fetchpriority="high"
              className="tw-block bs-tablet:tw-hidden tw-w-full tw-h-full tw-object-cover"
              sources={mobileImgSrcs}
              alt={imgAlt || title}
            />
          </div>

          <div
            className={`bs-tablet:tw-absolute bs-tablet:tw-top-0 bs-tablet:tw-left-0 bs-tablet:tw-bottom-0 bs-tablet:tw-right-0 tw-flex tw-h-fit tw-items-center bs-tablet:tw-w-full bs-tablet:tw-h-full tw-justify-center ${textBoxPosition === 'left' ? 'bs-tablet:tw-justify-start' : 'bs-tablet:tw-justify-end'}`}
          >
            <div
              className={beTwMerge(
                `tw-text-be-dark-gray tw-pt-10 tw-pb-0 bs-tablet:tw-py-6 tw-px-4 bs-tablet:tw-px-6 tw-flex bs-tablet:tw-max-w-[412px] tw-flex-col tw-gap-y-4 tw-justify-center`,
                isWhiteBackgroundVisible && 'tw-bg-white tw-bg-opacity-80',
                isTextWhite && 'bs-tablet:tw-text-color-white'
              )}
            >
              <div>
                <TitleTag
                  className={beTwMerge('tw-text-center tw-m-0 tw-pointer-events-none', subHeadersStyles[TitleTag])}
                >
                  {title}
                </TitleTag>
              </div>

              {!isRichTextEmpty(description) && (
                <div>
                  <RichText
                    className="tw-text-inherit tw-text-center tw-cursor-default"
                    content={description}
                    isTextWhite={isTextWhite}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
